import { Clear as ClearIcon } from '@mui/icons-material';
import {
  Box,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  styled,
  Typography,
} from '@mui/material';

import { HoverIconButton } from '../widget/selectDropdownWidget/SelectDropdownWidget.styled';

export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 190,
      width: 150,
    },
  },
};

export const Container = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const ClearIconWrapper = styled(Box)`
  margin: 0px 0px -15px 15px;
`;

export const IconWrapper = styled(IconButton)(
  ({ theme }) => `
  background-color: ${theme.palette.secondary.lighter};
  height: 24px;
  width: 24px;
`,
);

export const ClearIconStyled = styled(ClearIcon)`
  font-size: 1rem;
`;

export const SelectMenu = styled(Select)<{
  disabled?: boolean;
  $rounded?: boolean;
  $selectPadding?: string | number;
}>(
  ({ theme, disabled, $rounded, $selectPadding }) => `
   &.Mui-disabled .MuiOutlinedInput-notchedOutline{
    border-color: ${
      disabled ? theme.palette.grey[200] : theme.palette.primary.main
    }; 
  }
  ${
    $rounded
      ? `
  & .MuiOutlinedInput-root {
    border-radius: 50px;
  }
  & .MuiOutlinedInput-notchedOutline {
    border-radius: 50px;
  }
`
      : ''
  }
  & .MuiSelect-select {
    display: flex;
    align-items: center;
    gap: 6px;
    ${$rounded ? 'border-radius: 50px;' : ''}
    ${
      $selectPadding !== undefined
        ? `padding: ${
            typeof $selectPadding === 'number'
              ? `${$selectPadding}px`
              : $selectPadding
          } !important;`
        : ''
    }
  }
`,
);
export const MenuItems = styled(MenuItem)<{
  hoverColor?: string;
}>(
  ({ theme, hoverColor }) => `
    display: flex;
    justify-content: space-between;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    
    &:hover ${HoverIconButton} {
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${theme.palette.primary.main};
    }

    ${
      hoverColor
        ? `
        &:hover {
          background-color: ${hoverColor};
        }
      `
        : ''
    }
  `,
);

export const MenuItemsText = styled('p')`
  margin: 0;
`;

export const StyledInputLabel = styled(InputLabel)<{
  disabled?: boolean;
  $hasLabel?: boolean;
}>(
  ({ theme, disabled, $hasLabel }) => `
    color: ${
      disabled ? theme.palette.grey[200] : theme.palette.secondary.light
    };
    margin-top: ${$hasLabel ? '25px' : '0'};
  `,
);

export const SelectedTextWrapper = styled(Typography)`
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SelectedBadgeWrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
  overflow: hidden;
`;
